// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nli[data-v-4295d220] {\r\n  height: 40px;\r\n  line-height: 40px;\r\n  text-align: center;\r\n  background: #fff;\r\n  font-size: 14px;\r\n  cursor: pointer;\n}\nli.actived[data-v-4295d220] {\r\n  background: #2877ff;\r\n  color: #fff;\n}\r\n", ""]);
// Exports
module.exports = exports;
